import Mentorings from './container';

export default Mentorings;
